import React, { useEffect, useState } from "react";
import Layout from "../../../Components/Layout/Layout";
import { hidetoast, useDecodeToken } from "../../../Utils/function";
import { useNavigate } from "react-router-dom";
import RrbPageUi from "./RrbPageUi";
import {
  useAddRrbMutation,
  useDeleteRrbMutation,
  useEditRrbMutation,
  useGetRrbDataQuery,
} from "../../../store/Api/masterDataApi/rrb";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import  {rowsPerPage} from '../../../Utils/constant'

function RrbPage() {
  const navigate = useNavigate();
  const decodedToken = useDecodeToken();
  const [deleteRrb] = useDeleteRrbMutation();
  const [deleteId, setDeleteId] = useState("");
  const [updateData,setUpDateData] = useState("");
  const [showForm,setShowForm]=useState(false)
  const [tableQaury, setTableQaury] = useState({
    search: "",
    rowsPerPage: rowsPerPage,
    currentPage: 1,
  });
  const { data, isFetching, isLoading, refetch } = useGetRrbDataQuery({
    search: tableQaury.search,
    limit: tableQaury.rowsPerPage,
    page: tableQaury.currentPage,
  });
  const [isRRBError, setIsRRBError] = useState("");
  const [addRrb] = useAddRrbMutation();
  const [updateRrb] = useEditRrbMutation();
  const dispatch = useDispatch();
  const toast = useSelector((state) => state.toast);

  // Auto-hide toast after 3 seconds
 useEffect(() => {
    if (toast.message) {
       hidetoast()
    }
  }, [toast.message, dispatch]);
  
  const onUpdate = (data) => {
    navigate(`/master-data/update-rrb/${data?.id}`, { state: { data } });
  };
  const deleteFn = async () => {
    try {
      const response = await deleteRrb({ id: deleteId });
      if (response?.data?.success) {
        refetch();
      }
    } catch (error) {
      console.log(error, "verify otp error");
    }
  };

  const handlePageChange = (newPage) => {
    // setCurrentPage(newPage);
    setTableQaury({ ...tableQaury, currentPage: newPage });
  };
  const columns = [
    { title: "RRB", dataKey: "name" },
    {
      title: "Actions",
      render: (_, row) => (
        <div className="d-flex">
          {/* <button className="border-0 bg-transparent">
                <i class="fas fa-eye text-primary"></i>
              </button> */}
          <button
            className="border-0 bg-transparent"
            type="button"
          // data-toggle="modal"
          //   data-target="#modal-default"
            onClick={() => {setUpDateData(row);setShowForm(true) }}
            // onClick={()=>onUpdate(row)}
          >
            <i className="fas fa-edit text-success"> </i>
          </button>
          <button
            className="border-0 bg-transparent"
            type="button"
            data-toggle="modal"
            data-target="#modal-danger"
            onClick={() => setDeleteId(row?.id)}
          >
            <i className="fas fa-trash text-danger"> </i>
          </button>
        </div>
      ),
    },
  ];

  const handleSubmit = async (values, { resetForm }) => {
    let isError = false;
    if (values.rrbs) {
      values.rrbs.forEach((name) => {
        if (!name.trim()) {
          isError = true;
        }
      });
    } else {
      isError = true;
    }
    if (isError) {
      setIsRRBError("RRB Name is required");
    } else {
      const data = updateData?.id
        ? {       
            name: values?.rrbs[0],
          }
        : {  
          rrbs: values?.rrbs,
          };
      try {
        const response = updateData?.id
          ? await updateRrb({ id:updateData?.id, data })
          : await addRrb(data);
          
        if (response?.data?.success) {        
          setUpDateData(""); 
          setShowForm(false);
          setIsRRBError("")
        }
      } catch (error) {
        console.log(error, "verify RRB error");
      }
    }
  };
  const handleChange = (formik, index, value) => {
    const currentCens = [...formik?.values?.rrbs];
    currentCens[index] = value;
    setIsRRBError("")
    formik.setFieldValue("rrbs", currentCens);
  };
const handleCloseModal = () => setShowForm(false);

  return (
    <Layout>
      <RrbPageUi
        columns={columns}
        data={data?.data?.data || []}
        totalRecords={data?.data?.totalItems}
        loading={isLoading}
        tableQaury={tableQaury}
        onPageChange={handlePageChange}
        deleteFn={deleteFn}
        setTableQaury={setTableQaury}
        decodedToken={decodedToken}
        setUpDateData={setUpDateData}
        setShowForm={setShowForm}
        updateData={updateData}
        showForm={showForm}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        handleCloseModal={handleCloseModal}
        isRRBError={isRRBError}
        toast={toast}
      />
     
    </Layout>
  );
}

export default RrbPage;
